// extracted by mini-css-extract-plugin
module.exports = {"PolicyTemplate":"PolicyTemplate___3rsK4","header":"header___3RZvV","navs":"navs___38rn6","content":"content___1dK10"};